import React from 'react'
import { MappingsContainer } from 'src/components/Reusable/Mappings/Mappings.styles'
import { TabCard } from 'src/components/Reusable/Tabs/Tabs.styles'
import { EvidenceToControlMappingInfo } from '@trustero/trustero-api-web/lib/evidencemgmt/evidencemgmt_pb'
import { EvidenceControlMappingSuggestedControls } from 'src/pages/Evidence/mappings/EvidenceControlMappings'

export const EvidenceControlMappingsBody = ({
  mapping,
}: {
  mapping: EvidenceToControlMappingInfo
}): JSX.Element | null => {
  const evidence = mapping.getEvidence()
  if (!evidence) {
    return null
  }
  return (
    <TabCard>
      <MappingsContainer>
        <EvidenceControlMappingSuggestedControls
          mapping={mapping}
          evidence={evidence}
        />
      </MappingsContainer>
    </TabCard>
  )
}
